var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { LoadingService } from './../../../services/loading.service';
import { BountiesFiltersComponent } from './../bounties-filters/bounties-filters.component';
import { OnInit, OnDestroy } from '@angular/core';
import { BountyService } from '../../../services/bounty.service';
import { UserService } from 'src/app/services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { sortableFields } from 'src/app/resolvers/bounties.resolver';
var BountiesListComponent = /** @class */ (function () {
    function BountiesListComponent(bountyService, userService, router, route, loadingService) {
        var _this = this;
        this.bountyService = bountyService;
        this.router = router;
        this.route = route;
        this.loadingService = loadingService;
        this.page = 1;
        this.selectedFilters = [];
        this.fetching = false;
        this.sortableFields = sortableFields;
        this.selectedSort = this.sortableFields[0].value;
        this.showInstructions = false;
        this.activeTab = 'active';
        this.subscriptions = [];
        this.onWindowScroll = function () { return __awaiter(_this, void 0, void 0, function () {
            var scrollBottom;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        scrollBottom = document.body.scrollHeight - window.innerHeight - window.scrollY;
                        if (!(scrollBottom < 130 && !this.fetching)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.nextPage()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        this.user = userService.getUser();
        this.allTabs = (['active', 'completed'].concat(this.user ? ['liked'] : []));
    }
    BountiesListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscriptions.push(this.route.data.subscribe(function (_a) {
            var data = _a.data;
            // Get the resolved data
            var _b = data.listResults, bounties = _b.bounties, activeCount = _b.activeCount, likedCount = _b.likedCount, completedCount = _b.completedCount, hasMorePages = _b.hasMorePages, appliedFilters = data.appliedFilters, appliedSort = data.appliedSort, appliedTab = data.appliedTab, search = data.search, page = data.page;
            _this.selectedFilters = appliedFilters;
            _this.bounties = bounties;
            _this.activeCount = activeCount;
            _this.completedCount = completedCount;
            _this.likedCount = likedCount;
            _this.selectedSort = appliedSort;
            _this.activeTab = appliedTab;
            _this.searchInput = search;
            _this.searchTerm = search;
            _this.moreToFetch = hasMorePages !== false;
            _this.page = parseInt(page, 10) || 1;
        }));
        window.addEventListener('scroll', this.onWindowScroll, true);
        // Subscribe to search input changes
        this.searchInputEl.valueChanges
            .pipe(debounceTime(1000))
            .subscribe(function (value) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (value === this.searchTerm) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.onFiltersChanged({ search: value })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    BountiesListComponent.prototype.toggleFiltersSection = function () {
        this.filtersComponent.toggle();
    };
    BountiesListComponent.prototype.toggleSortSelect = function () {
        document.querySelector('sui-select').dispatchEvent(new MouseEvent('click'));
    };
    BountiesListComponent.prototype.ngOnDestroy = function () {
        window.removeEventListener('scroll', this.onWindowScroll, true);
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    BountiesListComponent.prototype.resetFilters = function () {
        this.selectedFilters = [];
        this.searchTerm = undefined;
        this.searchInput = undefined;
        this.onFiltersChanged();
    };
    BountiesListComponent.prototype.removeFilter = function (filter) {
        this.onFiltersChanged({
            filters: this.selectedFilters.filter(function (val) { return val !== filter; }),
        });
    };
    BountiesListComponent.prototype.addFilter = function (filter) {
        var filters = this.selectedFilters.includes(filter)
            ? this.selectedFilters
            : this.selectedFilters.concat([filter]);
        this.onFiltersChanged({ filters: filters });
    };
    BountiesListComponent.prototype.clearSearch = function () {
        this.searchInput = undefined;
        this.onFiltersChanged({ search: '' });
    };
    BountiesListComponent.prototype.onFiltersChanged = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, tab, _c, filters, _d, sort, _e, search, _f, page;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _a = data || {}, _b = _a.tab, tab = _b === void 0 ? this.activeTab : _b, _c = _a.filters, filters = _c === void 0 ? this.selectedFilters : _c, _d = _a.sort, sort = _d === void 0 ? this.selectedSort : _d, _e = _a.search, search = _e === void 0 ? this.searchTerm : _e, _f = _a.page, page = _f === void 0 ? null : _f;
                        this.page = 1;
                        this.moreToFetch = true;
                        return [4 /*yield*/, this.router.navigate(['.'], {
                                queryParams: {
                                    tab: tab,
                                    filters: filters.join(','),
                                    sort: sort,
                                    search: search,
                                    page: page,
                                },
                                queryParamsHandling: 'merge',
                            })];
                    case 1:
                        _g.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BountiesListComponent.prototype.nextPage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var page, _a, bounties, activeCount, likedCount, completedCount, hasMorePages, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this.moreToFetch) {
                            return [2 /*return*/];
                        }
                        page = this.page + 1;
                        this.fetching = true;
                        return [4 /*yield*/, this.loadingService.loadWhileFetching(this.bountyService.list({
                                page: page,
                                filters: this.selectedFilters,
                                sort: this.selectedSort,
                                tab: this.activeTab,
                                search: this.searchTerm,
                            }))];
                    case 1:
                        _a = _c.sent(), bounties = _a.bounties, activeCount = _a.activeCount, likedCount = _a.likedCount, completedCount = _a.completedCount, hasMorePages = _a.hasMorePages;
                        this.page = page;
                        this.activeCount = activeCount;
                        this.completedCount = completedCount;
                        this.likedCount = likedCount;
                        this.moreToFetch = hasMorePages !== false;
                        if (this.bounties) {
                            (_b = this.bounties).push.apply(_b, (bounties || []));
                        }
                        else {
                            this.bounties = bounties;
                        }
                        this.fetching = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    BountiesListComponent.prototype.changeTab = function (tab) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onFiltersChanged({ tab: tab })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BountiesListComponent.prototype.totalLabelLoadingClass = function (count) {
        return typeof count === 'number' ? '' : 'notched circle loading icon';
    };
    BountiesListComponent.prototype.tabsCount = function (tab) {
        switch (tab) {
            case 'active':
                return this.activeCount;
            case 'completed':
                return this.completedCount;
            case 'liked':
                return this.likedCount;
        }
    };
    return BountiesListComponent;
}());
export { BountiesListComponent };
